import React from "react"
import { NoTableData, Table, TableContainer, Td, Th } from "~styled/table"
import LoadingTable from "~components/LoadingTable"
import SkeletonWrapper from "~components/SkeletonWrapper"
import { PerkEligibility } from "~shapes/eligibility"
import EligibilityRow from "~components/eligibility/EligibilityRow"

export interface EligibilityListProps {
  eligibilities: PerkEligibility[] | undefined
  isLoading: boolean
  fetchNextPage?: () => void
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
}

const columns = [
  { id: "logo", label: "", width: "44px" },
  { id: "perk-title", label: "Perk", width: "auto" },
  { id: "company", label: "Company", width: "90px" },
  { id: "rules", label: "Eligibility rules", width: "auto" },
  { id: "holdings", label: "Holdings", width: "90px" },
  { id: "eligible", label: "Status", width: "120px" },
  { id: "redeemed", label: "Redeemed", width: "90px" },
]

const EligibilityList = ({
  eligibilities,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: EligibilityListProps) => {
  const isFirstLoad: boolean = !eligibilities && isLoading

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.currentTarget
    const bottom =
      target.scrollHeight - target.scrollTop <= target.clientHeight + 50
    if (bottom && fetchNextPage && hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }

  return (
    <TableContainer
      onScroll={handleScroll}
      style={{ maxHeight: "520px", overflowY: "auto" }}
    >
      <Table style={{ tableLayout: "auto" }}>
        <thead>
          <tr>
            {columns.map(col => (
              <Th
                $sticky
                key={col.id}
                style={{
                  width: col.width,
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "uppercase" as const,
                  letterSpacing: "0.4px",
                  paddingBottom: 10,
                }}
              >
                {col.label}
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isFirstLoad && (
            <LoadingTable rowHeight="50px" columns={7}>
              <Td>
                <SkeletonWrapper
                  isLoading={true}
                  className="skeleton-image"
                  width={32}
                />
              </Td>
            </LoadingTable>
          )}

          {!!eligibilities &&
            eligibilities.map((eligibility: PerkEligibility) => (
              <EligibilityRow
                key={eligibility.id}
                eligibility={eligibility}
                isLoading={isLoading}
              />
            ))}
        </tbody>
      </Table>

      {!eligibilities?.length && !isLoading && (
        <NoTableData style={{ fontSize: 13, color: "#7C8495" }}>
          No eligibility data found.
        </NoTableData>
      )}
    </TableContainer>
  )
}

export default EligibilityList
